import {FunctionComponent} from 'react'
import Home from 'routes/Home';
import EmailNotVerified from './EmailNotVerified';
import { Loading } from 'components/common/Loading';
import { Container } from '@mui/material';

export interface DefaultProps {
  emailVerified: boolean;
  isLoading: boolean;
  isAuthenticated: boolean;
  token: string;
  component: any;
}

export const Default: FunctionComponent<DefaultProps> = 
  ({emailVerified, isLoading = true, isAuthenticated, token, component}) => {  // Remove default values

  // Show loading while Auth0 is initializing or fetching token
  if (isLoading) {
    return (
      <Container maxWidth="md">
        <Loading variant='walker' height='390px'/>
      </Container>
    );
  }

  // Show loading while waiting for token after authentication
  if (isAuthenticated && !token) {
    return (
      <Container maxWidth="md">
        <Loading variant='walker' height='390px'/>
      </Container>
    );
  }

  // Show email verification if needed
  if (isAuthenticated && token && !emailVerified) {
    return <EmailNotVerified />;
  }

  // Show dashboard only when fully authenticated and verified
  if (isAuthenticated && token && emailVerified) {
    return component;
  }

  // Show home as the fallback
  return <Home />;
}

export default Default;